import { useMainParticipant, useParticipants, useScreenShareParticipant, useVideoContext } from '@uplift/hooks';
import { VideoCallLayoutProps } from './components';
import { Participant } from '@uplift/ui-v2';

export const useVideoCallParticipants = (): VideoCallLayoutProps['participants'] => {
  const { room } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const participants = useParticipants();
  const mainParticipant = useMainParticipant();
  const screenShareParticipant = useScreenShareParticipant();

  if (participants.length === 0 || !localParticipant) {
    return []; // Don't render this component if there are no remote participants.
  }

  return [
    {
      participant: <Participant participant={localParticipant} isLocalParticipant/>,
      id: localParticipant.sid
    },
    ...participants.map(participant => {
      const hideParticipant = participant === mainParticipant && participant !== screenShareParticipant;

      return {
        participant: (
          <Participant
            key={participant.sid}
            participant={participant}
            hideParticipant={hideParticipant}
          />
        ),
        id: participant.sid
      };
    })
  ].filter(x => x);
};